module.exports = __webpack_public_path__ + "img/icon01.c4ff840c.png";